module.exports = __webpack_public_path__ + "static/media/assist.c91a2337.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/assist.png
// module id = 387
// module chunks = 0